import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { MyProvider } from './Context/MyProvider';
import { SnackbarProvider } from 'notistack';
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MyProvider>
        <SnackbarProvider maxSnack={1} autoHideDuration={3000}>
          <GoogleOAuthProvider clientId="750348896218-t0gvl5584vue6gpdeou20d50l4fohpss.apps.googleusercontent.com">
            <App />
          </GoogleOAuthProvider>
        </SnackbarProvider>
      </MyProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
